export enum ProjectPDFGeneralDataOption {
  REMARKS = "remark",
  PRODUCT_DESCRIPTION = "product_description",
  DIMENSIONING_DATA = "dimensioning_data",
  DELIVERY_TIME = "delivery_time"
}

export enum ProjectPDFRoomDataOption {
  DIMENSIONS_DATA = "room_dimensions",
  AIR_DATA = "room_air",
  REMARK = "room_remark"
}

export enum ProjectPDFPriceOption {
  NO_PRICES = "NO_PRICES",
  PRICES_ONLY = "PRICES_ONLY",
  PRICES_AND_GROUPS = "PRICES_AND_GROUPS"
}

export enum ProjectPDFInstallationReferencesOption {
  NO_INSTALLATION_REFERENCES = "NO_INSTALLATION_REFERENCES",
  IMAGES = "IMAGES",
  QR_CODE = "QR_CODE",
  QR_CODE_AND_IMAGE = "QR_CODE_AND_IMAGE"
}
